import Head from 'next/head'
import blogCache from '../../../cache/blogCache.json'
import { getAllBlogPosts, getBlogFeatureInfo, getBlogPost } from '../../queries/blog'
import { getPerenderedChallenges } from '../../queries/create'
import { getPrerenderedInspirations } from '../../queries/posts'
import NotFoundPage from '../../routes/404'
import BlogPost from '../../routes/BlogPost'

const Routes = ({ data, categories, readMorePosts, inspiration, challenge, featureLine }) => {
  if (!data || !data[0]) return <NotFoundPage />

  const content = data[0].attributes

  return (
    <>
      <Head>
        <title>{content?.seo?.metaTitle || content.title}</title>
        <meta name="description" content={content?.seo?.metaDescription || content.short_description} />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content={`https://www.decormatters.com/blog/${content.slug}`} />
        <meta name="twitter:title" content={content?.seo?.metaTitle || content.title} />
        <meta name="twitter:image" content={content?.cover_image?.data?.attributes?.url} />
        <meta name="twitter:site" content="@decormattersapp" />
        <meta property="og:url" content={`https://www.decormatters.com/blog/${content.slug}`} />
        <meta property="og:title" content={content?.seo?.metaTitle || content.title} />
        <meta property="og:description" content={content?.seo?.metaDescription || content.short_description} />
        <meta property="og:site_name" content="DecorMatters" />
        <meta property="og:type" content="article" />
        <meta property="og:image" content={content?.cover_image?.data?.attributes?.url} />
      </Head>
      <BlogPost featureLine={featureLine} categories={categories} post={data[0]} readMorePosts={readMorePosts.data} inspiration={inspiration} challenge={challenge} />
    </>
  )
}

export default Routes

export async function getStaticPaths() {
  try {
    const allPosts = await getAllBlogPosts({ isFeatured: null }, false, -1, '')

    const paths = allPosts?.data?.map(post => {
      return {
        params: { postSlug: post.attributes.slug }
      }
    })

    return {
      paths,
      fallback: false // can also be true or 'blocking'
    }
  } catch (error) {
    console.log(error)

    return { fallback: false }
  }
}

export async function getStaticProps({ params }) {
  try {
    const content = await getBlogPost(params)
    const featureLine = await getBlogFeatureInfo()
    const inspirations = await getPrerenderedInspirations()
    const challenges = await getPerenderedChallenges()

    return {
      props: {
        ...content,
        ...blogCache,
        inspiration: inspirations.result.userInspirations[0],
        challenge: challenges.result.designContests[0],
        featureLine
      }
    }
  } catch (error) {
    console.log(error)
    return {
      props: {}
    }
  }
}
